
import { ref } from 'vue';
import { computed, defineComponent } from '@vue/runtime-core';
import _ from 'lodash';

import SearchAndAdd from './SearchAndAdd.vue';
import ToDoItem from './ToDoItem.vue';
import SortValue from './SortValue.vue';
import SortDate from './SortDate.vue';

export default defineComponent({
  components: {
    SearchAndAdd,
    ToDoItem,
    SortValue,
    SortDate
  },
  name: 'ToDo',
  setup () {
      const todosData = JSON.parse(localStorage.getItem('todos') as any) || []; 
      const todos = ref(todosData);
      const searchText=ref('');
      let isAlreadyExists=ref(false);
      function addTodo (newTodo:any) {
        if(newTodo){
          todos.value.push({
              content: newTodo,
              addedDate: new Date().toString()
          });
          saveData();
          searchText.value='';
        }
      }
      
      function searchChange (newTodo:any) {
          searchText.value=newTodo;
          isAlreadyExists.value=todos.value.some(
            (todo:any) => todo.content.toLowerCase().trim() === newTodo.toLowerCase().trim()
          );
      }      

      const filteredList=computed(()=>{
        return todos.value.filter(
          (todo:any) => todo.content.toLowerCase().includes(searchText.value.toLowerCase())
        );
      });
      
      function removeTodo (index: any) {
          todos.value.splice(index, 1);
          saveData();
      }
      function sortValueClick () {
        todos.value=_.orderBy(todos.value, 'content', 'asc');       
      }
      function sortDateClick () {
        todos.value=_.orderBy(todos.value, function(todo) {return new Date(todo.addedDate)}, 'desc');       
      }
      function saveData () {
          const storageData = JSON.stringify(todos.value);
          localStorage.setItem('todos', storageData);
      }
      function checkIfAlreadyExists (todo:any) {
          return todo.content.toLowerCase() === searchText.value.toLowerCase()
      }
      return {
          todos,
          addTodo,
          removeTodo,
          saveData,
          filteredList,
          searchChange,
          searchText,
          sortValueClick,
          sortDateClick,
          checkIfAlreadyExists,
          isAlreadyExists,
      }
  }
})
